enum ColumnPosition {
    Left = `left`,
    Right = `right`
}

export default ColumnPosition; 